import React from 'react';
import { useEffect, useState, useRef } from "react";
import NavButton from '../../homepage/header-banner/TopNavButton';
import ServerPricing from '../../homepage/header-banner/ServerPricing';
import Footer from '../../homepage/footer/Footer'
import Cloudconsult from '../../homepage/consult/cloudconsult';
import CloudconsultCp from '../../homepage/consult/cloudconsult-cp';
import Banner from '../../container/Banner/Banner';
import {
    Container, Row, Col
} from 'react-bootstrap';
import Sidebar from '../../container/Sidebar/Sidebar'
// import '../../container/Sidebar/sidebar.css'
import Titlecloudcompute from "../../container/Card/Components/Titlecloudcompute"
import Contentcloudcard from "../../container/Card/Components/Contentcloudcard"
import Imagecloudcompute from "../../container/Card/Components/Imagecloudcompute"
import CardBoxRow from '../../container/Box/Components/CardBox-Row'
// import { MuiGrid } from '@mui/material';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import CommonTable from '../../container/Table/Components/CommonTable';
import 'bootstrap/dist/css/bootstrap.min.css';
import '../../kubernetes/asset/css/style.css';
import '../../Style/typo.css'
import { Grid } from '@mui/material';
import Cloudconsult2 from '../../homepage/consult/cloudconsult-2';
import BannerPrivateCloud from '../../container/Banner/banner-privateCloud';
import DividerComponent from '../../container/Divider/divider';
import styled from 'styled-components';
import useIsMobile from '../../container/Sidebar/useIsMobile';


const checkIcon = `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" width="12" height="12" fill="#7061ff"><path d="M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM369 209L241 337c-9.4 9.4-24.6 9.4-33.9 0l-64-64c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l47 47L335 175c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9z" /></svg>`
// Titlecloudcompute
function KubeBenefits() {
    const isMobile = useIsMobile();
    useEffect(() => {
        document.title = '장점 - Private Kubernetes - 프라이빗 클라우드';
    }, []);

    return (
        <div className='App'>
            <NavButton option={{
                // logo: logoKube,
                logo: "https://hanbiro.com/cloud/library/banner/hanbiro.svg",
                link: "https://hanbiro.com/",
                color: { backgroundColor: '#7061ff' },
                itemNavClass: "item-nav nav-pur",
                menuListProduct: "menu-list-product-item",
                menuListVora: "vora",
                menuListGroupware: "groupware",
                titleTab: "mb-3",
            }} />
            <BannerPrivateCloud />
            <Container className="main-body">
                <Row>
                    <Col md={12} lg={3}>
                        {!isMobile && <Sidebar />}
                    </Col>
                    <Col md={12} lg={9} className="right-content">
                        {/* {Titlecloudcompute("장점")} */}
                        {/* {Contentcloudcard(`Kubernetes 장점`)} */}

                        <MuiGrid item xs={12} sm={12}>{CardBoxRow(
                            "<p class='typo-21-sm typo-medium typo-black'>Kubernetes 장점</p>",

                            `
                            <div class="kube-card-txt">
                                <ul>
                                    <li><p class='typo-14'>온프레미스 또는 프라이빗 호스팅 서버 기반의 Kubernetes 클러스터 구축</p></li>
                                    <li><p class='typo-14'>글로벌 클라우드와 동일한 워크로드 오케스트레이션 및 오토스케일링 기능 제공</p></li>
                                    <li><p class='typo-14'>리소스 사용량과 무관한 고정형 또는 유연한 비용 구조</p></li>
                                    <li><p class='typo-14'>Prometheus, Grafana 등 통합 모니터링 스택 기본 제공</p></li>
                                    <li><p class='typo-14'>Stateful/Stateless 워크로드에 적합한 볼륨 관리 및 퍼시스턴트 스토리지 지원</p></li>
                                    <li><p class='typo-14'>기업 내부망 통합, 보안 정책 커스터마이징 가능</p></li>
                                <ul>
                            </div>
                            <div class="kube-card-txt">
                                <ul>
                                    <li><p class='typo-14'>서버자원: 서버자원의 효율적인 사용</p></li>
                                    <li><p class='typo-14'>서버확장 (Autoscale): 서비스운영중 서버를 자유롭게 확장</p></li>
                                    <li><p class='typo-14'>무정지서비스: 재해복구, 서비스의 영속성</p></li>
                                    <li><p class='typo-14'>Cluster: 서버의 자동 확장, 로드발랜싱</p></li>
                                    <li><p class='typo-14'>Application: Microservice 플랫폼 운영</p></li>
                                <ul>
                            </div>
                            `)}
                        </MuiGrid>
                        <DividerComponent />
                        <MuiGrid item xs={12} className='MuiGrid-card'>{Imagecloudcompute("https://hanbiro.com/assets/images/cloud/kube-node.png")}</MuiGrid>
                        <DividerComponent />
                        <Cloudconsult2 />
                    </Col>
                </Row>
            </Container>


            {/* <Cloudconsult /> */}
            <Footer option={{
                textColor: "text-color external-link text-pur-color",
                textlinkColor: "text-color text-pur-color"
            }} />
        </div>
    );
};

const MuiGrid = styled.div`
    padding: 0px,
`

export default KubeBenefits;